import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';
import { FullViewProps } from '../types';
import AutoSizedText from '../_partials/AutoSizedText';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import PremiumIconWithPopover from '../_partials/PremiumIconWithPopover';
import DeviationFlags from '../../../ActionBar/buttons/DeviationFlags';

import s from './Literature.scss';

const LiteratureFullView: React.FC<FullViewProps> = ({
  deviation: { dailyDeviation },
  deviation,
  width,
  height,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { isFullscreen, isTheater } = useDeviationViewContext();
  const style = (isTheater || isFullscreen) && !isMobile ? { width, height } : { width };
  const { isPremium, isPaidFolder } = normalizePremiumFolderData(deviation?.premiumFolderData);

  const deviationTitle = getDeviationTitle(deviation);

  return (
    <div
      className={classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'])}
      style={style}
    >
      <div className={s['letter-wrap']}>
        <div className={s['letter']}>
          <LiteratureCoverLetter alignment="start" title={deviationTitle} />
        </div>
      </div>
      <div className={s['content-wrap']}>
        <div className={classnames(s['title-wrap'], isMobile && dailyDeviation && s['with-flag'])}>
          {isMobile && dailyDeviation && (
            <div className={s['flag']}>
              <DeviationFlags deviation={deviation} />
            </div>
          )}
          <div className={s['tag']}>
            {isPremium && (
              <PremiumIconWithPopover className={s['premium-icon']} isPaidFolder={isPaidFolder} />
            )}
            {t('common.literature')}
          </div>
          <AutoSizedText className={s['title']} tooBigClassName={s['better-fit']} maxHeight={180}>
            {deviationTitle}
          </AutoSizedText>
        </div>
        {isFullscreen && <TextualContent deviation={deviation} withArtist={false} />}
      </div>
    </div>
  );
};
LiteratureFullView.displayName = 'LiteratureFullView';

export default LiteratureFullView;
